import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";

import { error_message } from "../../constants/constants";
import {
	CLEAR_USER_META_CONFIG,
	FETCH_USER_META_CONFIG_FAILED,
	FETCH_USER_META_CONFIG_PROGRESS,
	FETCH_USER_META_CONFIG_SUCCESS,
} from "./metaDataActions";
import { initialMetaData, initialMetaDataState } from "./defaultState";

export const metaDataReducer = (
	state: IStoreState["metaData"] = initialMetaDataState,
	action: any
) => {
	switch (action.type) {
		// User Meta Config Actions
		case FETCH_USER_META_CONFIG_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.metaData.loading = LoadState.InProgress;
				draftState.metaData.data = initialMetaData;
			});
		}

		case FETCH_USER_META_CONFIG_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.metaData.loading = LoadState.Loaded;
				draftState.metaData.data = data;
				draftState.metaData.error = null;
			});
		}

		case FETCH_USER_META_CONFIG_FAILED: {
			return produce(state, (draftState) => {
				draftState.metaData.loading = LoadState.Failed;
			});
		}

		case CLEAR_USER_META_CONFIG: {
			return produce(state, (draftState) => {
				draftState.metaData.data = initialMetaData;
			});
		}

		default: {
			return state;
		}
	}
};
